<template>
  <v-container fluid class="pa-5">
    <v-layout align-center justify-center my-2>
      <v-flex class="headline">
        Algoritmo de selección
      </v-flex>
    </v-layout>

    <v-layout row wrap mt-3 mb-4>
      <v-flex md5 pr-3>
        <v-text-field
          v-model="search"
          label="Buscar..."
          color="black"
          solo
        ></v-text-field>
      </v-flex>
      <v-flex md3>
        <v-select
          v-model="filters.algorithm"
          :items="algorithmOptions"
          label="Estatus"
          color="black"
          clearable
          solo
        ></v-select>
      </v-flex>
    </v-layout>

    <data-table
      url="numx/call_center/algorithm/users"
      :search="search"
      :filters="filters"
      :limit="15"
      @items-reload="users = $event"
    >
      <template slot="content" v-for="(user, i) in users">
        <v-list-tile :key="`user-${user.id}`" avatar>
          <v-list-tile-avatar>
            <v-icon class="k-orange-linear-text" large>fas fa-user</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              <strong>{{ capitalize(user.first_name) }} {{ capitalize(user.last_name) }}</strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                icon
                :disabled="!canEdit || updating === user.id"
                @click="toggleAlgorithm(user)"
              >
                <v-icon :color="user.call_center_custom_algorithm ? 'green' : 'grey lighten-2'">
                  {{ user.call_center_custom_algorithm ? 'fas fa-check-circle' : 'far fa-circle' }}
                </v-icon>
              </v-btn>
              <span>{{ user.call_center_custom_algorithm ? 'Desactivar algoritmo' : 'Activar algoritmo' }}</span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider v-if="i !== users.length - 1" :key="`divider-${user.id}`"></v-divider>
      </template>
    </data-table>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top :timeout="3000">
      {{ snackbar.message }}
      <v-btn flat @click="snackbar.show = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import DataTable from '@/components/global/DataTable2';
import permissionsMixin from '@/mixins/permissions';

export default {
  name: 'NumxCallCenterAlgorithm',
  components: { DataTable },
  mixins: [permissionsMixin],
  data() {
    return {
      users: [],
      search: '',
      updating: null,
      filters: {
        algorithm: null,
      },
      algorithmOptions: [
        { text: 'Activo', value: 1 },
        { text: 'Inactivo', value: 0 },
      ],
      snackbar: {
        show: false,
        message: '',
        color: 'success',
      },
    };
  },
  computed: {
    canEdit() {
      return this.checkPermissions(['numx_edit_call_center_algorithm']);
    },
  },
  methods: {
    capitalize(str) {
      if (!str) return '';
      return str.replace(/\b\w/g, c => c.toUpperCase());
    },
    toggleAlgorithm(user) {
      this.updating = user.id;
      const newValue = !user.call_center_custom_algorithm;
      this.axios.patch(`numx/call_center/algorithm/users/${user.id}`, {
        call_center_custom_algorithm: newValue,
      }).then(() => {
        user.call_center_custom_algorithm = newValue;
        this.showSnackbar('Algoritmo actualizado correctamente', 'success');
      }).catch(() => {
        this.showSnackbar('Error al actualizar el algoritmo', 'error');
      }).finally(() => {
        this.updating = null;
      });
    },
    showSnackbar(message, color) {
      this.snackbar = { show: true, message, color };
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Numx/CallCenterAlgorithm/Index.vue